import { createSlice } from '@reduxjs/toolkit';
import { mockProductsData } from '../../mock/productsData';

export const productSlice = createSlice({
  name: 'product',
  initialState: {
    loading: false,
    error: {},
    productList: {
      list: mockProductsData,
      total: mockProductsData.total,
    },
    productDetails: mockProductsData.products[0],
  },
  reducers: {},
});

export default productSlice.reducer;
